import { lang } from '@public/utils/filters'
import { DICT as parentDict } from '@public/utils/dict'
import workOrder from './dict/workOrder'
import quality from './dict/quality'
import onlineServicer from './dict/onlineServicer'
import microCallBoard from './dict/microCallBoard'
import flyingRabbit from './dict/flyingRabbit'
import qualityControl from './dict/qualityControl'
import qualityInspection from './dict/qualityInspection'


export const DICT = {
  // 呼叫方式
  callMode: [
    { value: 'WEB', label: lang('软电话'), name: lang('软电话') },
    { value: 'IAD', label: lang('外呼设备'), name: lang('外呼设备') },
    { value: 'MOBILE', label: lang('移动端'), name: lang('移动端') }
  ],
  // 通话类型
  callType: [
    { value: 'IN', label: lang('呼入'), name: lang('呼入') },
    { value: 'OU', label: lang('呼出'), name: lang('呼出') },
    { value: 'FI', label: lang('呼转'), name: lang('呼转') },
    { value: 'FL', label: lang('网点下放'), name: lang('网点下放') }
  ],
  // 通话状态
  callState: [
    { value: 1, label: lang('已接通'), name: lang('已接通') },
    { value: 2, label: lang('未接通'), name: lang('未接通') }
  ],
  // 挂机原因
  hangUpReason: [
    { value: 'CAlL_REJECTED', label: lang('用户拒绝'), name: lang('用户拒绝') },
    { value: 'USER_BUSY', label: lang('用户忙'), name: lang('用户忙') },
    { value: 'NO_ANSWER', label: lang('用户无应答'), name: lang('用户无应答') },
    { value: 'NO_USER_RESPONSE', label: lang('用户无响应'), name: lang('用户无响应') },
    { value: 'NORMAL_TEMPORARY_FAILURE', label: lang('正常临时失败'), name: lang('正常临时失败') },
    { value: 'TIMEOUT', label: lang('超时'), name: lang('超时') },
    { value: 'NO_ROUTE_DESTINATION', label: lang('没有渠道'), name: lang('没有渠道') },
    { value: 'ORIGINATOR_CANCEL', label: lang('取消呼叫'), name: lang('取消呼叫') },
    { value: 'NORMAL_CLEARING', label: lang('正常挂断'), name: lang('正常挂断') },
    { value: 'UNALLOCATED_NUMBER', label: lang('未知号码'), name: lang('未知号码') },
    { value: 'OTHER', label: lang('其他原因'), name: lang('其他原因') }
  ],
  hangUpParty: [
    { value: 'caller_bye', label: lang('主叫挂断'), name: lang('主叫挂断') },
    { value: 'called_bye', label: lang('被叫挂断'), name: lang('被叫挂断') },
    { value: 'caller_cancel', label: lang('主叫取消'), name: lang('主叫取消') },
    { value: 'called_refuse', label: lang('被叫拒绝'), name: lang('被叫拒绝') },
    { value: 'other', label: lang('其他'), name: lang('其他') }
  ],
  // 未接通原因
  notConnectedReason: [
    { value: 'POWER_OFF', label: lang('被叫关机'), name: lang('被叫关机') },
    { value: 'DOES_NOT_EXIS', label: lang('被叫空号'), name: lang('被叫空号') },
    { value: 'OUT_OF_SERVICE', label: lang('被叫停机'), name: lang('被叫停机') },
    { value: 'BUSY', label: lang('被叫忙'), name: lang('被叫忙') },
    { value: 'NOT_CONVENIENT', label: lang('被叫拒接'), name: lang('被叫拒接') },
    { value: 'IS_NOT_REACHABLE', label: lang('被叫暂时无法接通'), name: lang('被叫暂时无法接通') },
    { value: 'NOT_IN_SERVICE', label: lang('被叫暂停服务'), name: lang('被叫暂停服务') },
    { value: 'INCORRECT_NUMBER', label: lang('被叫号码有误'), name: lang('被叫号码有误') },
    { value: 'CALL_REMINDER', label: lang('被叫语音留言'), name: lang('被叫语音留言') },
    { value: 'FORWARDED', label: lang('被叫呼转失败'), name: lang('被叫呼转失败') },
    { value: 'NOT_ANSWER', label: lang('被叫无人接听'), name: lang('被叫无人接听') },
    { value: 'DEFAULTING', label: lang('被叫欠费'), name: lang('被叫欠费') },
    { value: 'CANNOT_BE_CONNECTED', label: lang('被叫无法接听'), name: lang('被叫无法接听') },
    { value: 'OTHER', label: lang('其他'), name: lang('其他') },
    { value: 'SILENCE', label: lang('被叫无声音'), name: lang('被叫无声音') }
  ],
  // 坐席状态
  agentStatusList: [
    { value: 'BUSY', label: lang('忙线'), name: lang('忙线') },
    { value: 'OFF_ONLINE', label: lang('离线'), name: lang('离线') }
  ],
  // 通话类型
  cdrTypeEnum: [
    { value: '', label: lang('全部'), name: lang('全部') },
    { value: 'IN', label: lang('呼入'), name: lang('呼入') },
    { value: 'OU', label: lang('呼出'), name: lang('呼出') },
    { value: 'FL', label: lang('网点下放'), name: lang('网点下放') },
    { value: 'FI', label: lang('呼转'), name: lang('呼转') },
    { value: 'IR', label: lang('呼入分流'), name: lang('呼入分流') }
  ],
  // 通话状态
  recordStateEnum: [
    { value: '', label: lang('全部'), name: lang('全部') },
    { value: '已接通', label: lang('已接通'), name: lang('已接通') },
    { value: '未接通', label: lang('未接通'), name: lang('未接通') }
  ],
  // 挂断方
  hangupPartyEnum: [
    { value: '', label: lang('全部'), name: lang('全部') },
    { value: 'caller_bye', label: lang('主叫挂断'), name: lang('主叫挂断') },
    { value: 'called_bye', label: lang('被叫挂断'), name: lang('被叫挂断') },
    { value: 'caller_cancel', label: lang('主叫取消'), name: lang('主叫取消') },
    { value: 'called_refuse', label: lang('被叫拒绝'), name: lang('被叫拒绝') },
    { value: 'other', label: lang('其他'), name: lang('其他') }
  ],
  // 未接通原因
  da2ResultEnum: [
    { value: '', label: lang('全部'), name: lang('全部') },
    { value: 'POWER_OFF', label: lang('被叫关机'), name: lang('被叫关机') },
    { value: 'DOES_NOT_EXIS', label: lang('被叫空号'), name: lang('被叫空号') },
    { value: 'OUT_OF_SERVICE', label: lang('被叫停机'), name: lang('被叫停机') },
    { value: 'BUSY', label: lang('被叫忙'), name: lang('被叫忙') },
    { value: 'NOT_CONVENIENT', label: lang('被叫拒接'), name: lang('被叫拒接') },
    { value: 'IS_NOT_REACHABLE', label: lang('被叫暂时无法接通'), name: lang('被叫暂时无法接通') },
    { value: 'NOT_IN_SERVICE', label: lang('被叫暂停服务'), name: lang('被叫暂停服务') },
    { value: 'INCORRECT_NUMBER', label: lang('被叫号码有误'), name: lang('被叫号码有误') },
    { value: 'CALL_REMINDER', label: lang('被叫语音留言'), name: lang('被叫语音留言') },
    { value: 'FORWARDED', label: lang('被叫呼转失败'), name: lang('被叫呼转失败') },
    { value: 'NOT_ANSWER', label: lang('被叫无人接听'), name: lang('被叫无人接听') },
    { value: 'DEFAULTING', label: lang('被叫欠费'), name: lang('被叫欠费') },
    { value: 'CANNOT_BE_CONNECTED', label: lang('被叫无法接听'), name: lang('被叫无法接听') },
    { value: 'SILENCE', label: lang('被叫无声音'), name: lang('被叫无声音') },
    { value: 'OTHER', label: lang('其他'), name: lang('其他') }
  ],
  ...quality,
  ...parentDict,
  ...workOrder, // 工单模块
  ...onlineServicer, // 在线客服
  ...microCallBoard, // 微呼客服接待实况看板
  ...flyingRabbit, // IM
  ...qualityControl,//之间管理
  ...qualityInspection,//质检系统
  // 网点级别
  networkLebel: [
    { value: 22, label: lang('总部'), name: '总部' },
    { value: 334, label: lang('代理区'), name: '代理区' },
    { value: 335, label: lang('中心'), name: '中心' },
    { value: 336, label: lang('网点'), name: '网点' }
  ],
  // 通用是否
  whetherOption: [
    { value: 1, label: lang('是'), name: '是' },
    { value: 2, label: lang('否'), name: '否' }
  ],
  // 网点维度
  NetworkDimension: [
    { value: '1', label: lang('代理区'), name: lang('代理区') },
    { value: '2', label: lang('加盟商'), name: lang('加盟商') },
    { value: '3', label: lang('网点'), name: lang('网点') }
  ],
  // 统计类型
  isRegistration: [
    { value: 1, label: lang('按登记方统计'), name: '按登记方统计' },
    { value: 2, label: lang('按接收方统计'), name: '按接收方统计' }
  ],
  // 网点类型
  networkType: [
    { value: 1, label: lang('网点'), name: '网点' },
    { value: 2, label: lang('集散点'), name: '集散点' },
    { value: 3, label: lang('转运中心'), name: '转运中心' }
  ],
  // 数据形式
  searchType: [
    { value: 1, label: lang('按天计'), name: '按天计' },
    { value: 2, label: lang('按总计'), name: '按总计' }
  ],
  // 通用男女
  sexType: [
    { value: 1, label: lang('男'), name: '男' },
    { value: 2, label: lang('女'), name: '女' }
  ],
  // 工单类型
  W_orkorderTypeTwo: [
    { value: 1, label: lang('普通工单'), name: lang('普通工单') },
    { value: 2, label: lang('理赔工单'), name: lang('理赔工单') },
    { value: 3, label: lang('项目工单'), name: lang('项目工单') },
    { value: 5, label: lang('邮政工单'), name: lang('邮政工单') }
  ],
  // 工单状态
  W_orkorderStatus: [
    { value: 0, label: lang('待分配'), name: lang('待分配') },
    { value: 1, label: lang('待处理'), name: lang('待处理') },
    { value: 2, label: lang('处理中'), name: lang('处理中') },
    { value: 3, label: lang('已关闭'), name: lang('已关闭') },
    { value: 4, label: lang('待审核'), name: lang('待审核') },
    { value: 5, label: lang('已答复'), name: lang('已答复') },
    { value: 6, label: lang('已拒绝'), name: lang('已拒绝') }
  ]
}
